import { Link } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div
            className="bg-cream min-h-[80vh] flex items-center justify-center px-6 py-16"
            data-testid="checkout-cancel-page"
        >
            <div className="max-w-xl w-full text-center">
                <div className="w-14 h-14 rounded-full bg-cream-warm border border-gold/40 mx-auto flex items-center justify-center">
                    <Info size={24} className="text-gold" />
                </div>
                <span className="divider-rule text-brown mt-8">
                    No worries
                </span>
                <h1 className="font-serif text-5xl md:text-6xl text-forest mt-4 leading-[1.02]">
                    Checkout{" "}
                    <span className="italic text-gold">cancelled.</span>
                </h1>
                <p className="mt-5 text-brown leading-relaxed">
                    Nothing was charged. Whenever you're ready to check out,
                    we'll be right here.
                </p>

                <div
                    className="mt-8 p-6 bg-cream-warm rounded-sm border border-forest/10 text-left"
                    data-testid="checkout-cancel-help"
                >
                    <p className="text-[0.65rem] tracking-[0.3em] uppercase text-gold mb-3">
                        Have a question first?
                    </p>
                    <p className="text-sm text-brown leading-relaxed">
                        Reach out to{" "}
                        <a
                            href="mailto:sales@eigooinc.net"
                            className="text-forest underline decoration-gold underline-offset-4 hover:text-gold transition-colors"
                            data-testid="checkout-cancel-email-link"
                        >
                            sales@eigooinc.net
                        </a>{" "}
                        and we'll help you find what you're looking for.
                    </p>
                </div>

                <div className="mt-10 flex flex-wrap gap-3 justify-center">
                    <Link
                        to="/"
                        className="btn-pill btn-primary"
                        data-testid="checkout-cancel-book-again-btn"
                    >
                        <ArrowLeft size={14} /> Try again
                    </Link>
                    <Link
                        to="/"
                        className="btn-pill btn-ghost"
                        data-testid="checkout-cancel-home-btn"
                    >
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
}
